import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AutoTriLogPanel } from '../components/AutoTriLogPanel';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function TriBetDashboardPage() {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/api/feed/tribet-access`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : { allowed: false }))
      .then(setAccess).catch(() => setAccess({ allowed: false }));
  }, []);
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 px-6 py-8" data-testid="tribet-dashboard">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold text-white">TriBet Dashboard</h1>
            <p className="text-sm text-slate-400 mt-1">Auto Tri Bet (Strong-key Trifecta) — Sent to ASP audit log</p>
          </div>
          <Link to="/" className="text-sm text-emerald-400 hover:text-emerald-300 transition-colors" data-testid="tribet-back-link">← Back to IntelliTix</Link>
        </div>
        {access === null && <p className="text-slate-500">Loading…</p>}
        {access && !access.allowed && (
          <p className="text-rose-400" data-testid="tribet-no-access">You don't have access to the TriBet Dashboard.</p>
        )}
        {access?.allowed && (
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
            {!access.admin && (
              <p className="text-xs text-slate-500" data-testid="tribet-window">
                Your history window: {access.min_date || 'start'} → {access.max_date}
              </p>
            )}
            <AutoTriLogPanel endpoint="/api/feed/tribet-log" minDate={access.min_date} maxDate={access.max_date} />
          </div>
        )}
      </div>
    </div>
  );
}
